import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const JordanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15209'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15209)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#199E56'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L9.52381 7L0 14V0Z'
					fill='#E6223A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M3.33287 7.69998L2.71303 8.26133L2.77442 7.43642L1.94011 7.31151L2.63649 6.84421L2.21597 6.12709L3.02295 6.3693L3.33287 5.59998L3.64279 6.3693L4.44977 6.12709L4.02925 6.84421L4.72562 7.31151L3.89132 7.43642L3.9527 8.26133L3.33287 7.69998Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default JordanFlagIcon;
